module.exports = __webpack_public_path__ + "img/Picture13.7d210dca.jpg";